// extracted by mini-css-extract-plugin
export default {"box":"personalNote_box__CwikF","text":"personalNote_text__ZrMKj","div":"personalNote_div__4CW8V"};